<div id="login-page" class="primary-background">
  <ng-container *ngIf="isInIframe; else loginform">
    <div class="login-page-iframe-view">
      <h6>{{ 'currently_logged_out' | translation }}</h6>
      <h6>{{ 'refresh_browser_log_back_in' | translation }}</h6>
    </div>
  </ng-container>
  <ng-template #loginform>
    <div id="login-form" class="align-center">
      <p-card>
        <p-card-body>
          <div class="school-logo-wrapper">
            <img id="school-logo" src="school-assets/school_logo.png" alt="" />
          </div>
          <div class="school-logo-wrapper-dark">
            <img
              id="school-logo-dark"
              src="school-assets/school_logo_dark.png"
              alt=""
              *ngIf="!darkLogoError; else loginDarkLogoFallback"
              (error)="darkLogoError = true" />
            <ng-template #loginDarkLogoFallback>
              <img id="school-logo-dark" src="school-assets/school_logo.png" alt="" />
            </ng-template>
          </div>
          <div id="error-wrapper">
            <p *ngIf="loginErrorMessage" id="error-msg">
              {{ loginErrorMessage }}
            </p>
          </div>
          <ng-container *ngIf="provideTotbChallenge">
            <p>{{ 'multi-factor_authentication' | translation }}</p>
            <p>{{ 'enter_a_mfa_code_to_complete_login' | translation }}</p>

            <form (keydown.enter)="submitChallenge('totb', $event)">
              <input
                [(ngModel)]="usercode"
                [ngModelOptions]="{ standalone: true }"
                pInputText
                [placeholder]="'mfa_code' | translation"
                style="margin: 10px" />
              <div style="padding-bottom: 10px">
                <app-button
                  class="login-page-button"
                  [isProcessing]="challengeSubmitted"
                  (click)="submitChallenge('totb', $event)"
                  type="submit"
                  style="border: none; margin: 10px"
                  [disabled]="!usercode || challengeSubmitted">
                  {{ 'submit' | translation }}
                </app-button>
              </div>
            </form>
          </ng-container>

          <ng-container *ngIf="provideSmsChallenge">
            <p>{{ 'multi-factor_authentication' | translation }}</p>
            <p>
              {{
                'provide_the_code_from_the_text_message_to_complete_login'
                  | translation
              }}
            </p>
            <form (keydown.enter)="submitChallenge('sms', $event)">
              <p-inputgroup>
                <input
                  [(ngModel)]="usercode"
                  [ngModelOptions]="{ standalone: true }"
                  pInputText
                  [placeholder]="'mfa_code' | translation" />
                <app-button
                  class="login-page-button"
                  (click)="submitChallenge('sms', $event)"
                  type="submit"
                  style="border: none; margin: 10px"
                  [isProcessing]="challengeSubmitted"
                  [disabled]="!usercode || challengeSubmitted">
                  {{ 'submit' | translation }}
                </app-button>
              </p-inputgroup>
            </form>
          </ng-container>

          <ng-container *ngIf="provideWhichMfaChallenge">
            <p>{{ 'how_do_you_want_to_get_authenticated?' | translation }}</p>
            <div class="mfa-option-button-wrapper">
              <app-button
                class="login-page-button"
                [disabled]="mfaSelectionMade"
                (click)="selectMfaOption('SMS_MFA')">
                {{ 'text_message' | translation }}
              </app-button>
              <app-button
                class="login-page-button"
                [disabled]="mfaSelectionMade"
                (click)="selectMfaOption('SOFTWARE_TOKEN_MFA')">
                {{ 'authenticator_app' | translation }}
              </app-button>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              !provideTotbChallenge &&
              !provideWhichMfaChallenge &&
              !provideSmsChallenge
            ">
            <form (keydown.enter)="onLoginFormEnter($event)">
              <p-inputgroup>
                <input
                  [(ngModel)]="username"
                  [ngModelOptions]="{ standalone: true }"
                  pInputText
                  [placeholder]="'username' | translation" />
              </p-inputgroup>
              <br />
              <div style="min-height: 40px">
                <p-inputgroup *ngIf="!showPasskeySignIn">
                  <input
                    [(ngModel)]="password"
                    [ngModelOptions]="{ standalone: true }"
                    pInputText
                    [placeholder]="'password' | translation"
                    [type]="passwordHidden ? 'password' : 'text'" />
                  <p-inputgroup-addon>
                    <p-button
                      [icon]="passwordHidden ? 'fa fa-eye-slash' : 'fa fa-eye'"
                      severity="secondary"
                      variant="text"
                      (click)="passwordHidden = !passwordHidden">
                    </p-button>
                  </p-inputgroup-addon>
                </p-inputgroup>
              </div>
              <div style="padding: 10px 0px">
                <div class="button-holder" style="flex-direction: column">
                  <div class="text-link-color" style="margin-bottom: 15px">
                    <a
                      routerLink="/forgot-password"
                      class="forgot-password-link">
                      {{ 'password_forgot' | translation }}?
                    </a>
                  </div>
                  <div style="display: flex; flex-direction: column; gap: 10px">
                    <app-button
                      *ngIf="!showPasskeySignIn"
                      [isProcessing]="isWorking"
                      type="button"
                      status="primary"
                      style="border: none"
                      [disabled]="!username || !password || isWorking"
                      (click)="onLoginFormSubmit()">
                      {{ 'signin' | translation }}
                    </app-button>
                    <app-button
                      *ngIf="showPasskeySignIn"
                      [isProcessing]="isWorking"
                      type="button"
                      status="primary"
                      style="border: none"
                      [disabled]="!username || isWorking"
                      (click)="onLoginFormSubmit()">
                      {{ 'signin' | translation }}
                    </app-button>
                    <div
                      class="auth-option-toggle"
                      *ngIf="showPasskeyLoginToggle">
                      <app-button
                        [disabled]="isWorking"
                        status="secondary"
                        (click)="togglePasskeySignIn()">
                        {{
                          showPasskeySignIn
                            ? ('use_password' | translation)
                            : ('use_passkey' | translation)
                        }}
                      </app-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </ng-container>
          <div class="security-note">
            <a href="https://www.k16solutions.com/security/" target="_blank">{{
              'security_information' | translation
            }}</a>
          </div>
        </p-card-body>
      </p-card>
    </div>
  </ng-template>
</div>
